(function ($, v, window) {

	$.fn.jsonconnect = function( options ) {

		let previousAjaxRequest = null;
		let dirtyFields = [];
		let lastFieldUpdate = {};

		const $me = $(this);

		const settings = $.extend({
			query: null,
			selector: 'input, select, textarea',
			updateatstart: true,
			mappings: [],
			beforeupdate: function() {},
			onupdate: function() {}
		}, options );

		if(settings.query !== null) $me.data('query', settings.query);

		$me.on('change', settings.selector, function(){
			dirtyFields.push( $(this).attr('name'));
			requestUpdate();
		});

		if(settings.updateatstart) {
			requestUpdate();
		}

		function requestUpdate() {

			if (!$me.data('query')) return;

			if(previousAjaxRequest !== null) {
				previousAjaxRequest.abort();
			}

			settings.beforeupdate.call($me);

			previousAjaxRequest = $.ajax({
				type: "POST",
				url: rootPath + $me.data('query'),
				data: $me.is('form') ? $me.serialize() : $me.closest('form').serialize(),
				//contentType: "application/json; charset=UTF-8",
				dataType: "json",
				success: function (data) {
					previousAjaxRequest = null;
					updateUi(data);
				}
			});
		}

		function updateUi(data) {

			if(data.sessionExpired) {
				window.location.href=util.getUrl("index", {'LOGIN_LOGOUT': '2'});
				return;
			}

			v.updateUiErrors(data);

			//Formularfeld Werte setzen
			for(let i=0; i< settings.mappings.length; i++) {

				const jsonName = settings.mappings[i][0];
				const htmlName = settings.mappings[i][1];

				const obj = data[jsonName];

				if($.isArray(obj)) {
					setArrayValues(jsonName, htmlName, data);
				} else {
					setObjectValue(obj, htmlName, data);
				}

			}

			settings.onupdate.call($me, data);
			dirtyFields = [];

			return true;

		}

		function setObjectValue(obj, htmlName, data) {
			for (let field in obj) {
				const fieldName = htmlName + "." + field;
				const objValue = obj[field];
				if(Array.isArray(objValue)) {
					for(let i=0; i< objValue.length; i++) {
						setObjectValue(objValue[i], fieldName + "[" + i + "]", data);
					}
				} else if(typeof objValue === 'object' && objValue != null) {
					setObjectValue(objValue, fieldName, data);
				} else {
					setFormField(fieldName, objValue, data);
				}
			}
		}

		function setArrayValues(jsonName, htmlName, data) {
			const arrayObj = data[jsonName];
			for(let i=0; i< arrayObj.length; i++) {
				const objValue = arrayObj[i];
				setObjectValue(objValue, htmlName + "[" + i + "]", data);
			}
		}

		function setFormField(fieldName, objValue, data) {

			if(lastFieldUpdate.hasOwnProperty(fieldName) && lastFieldUpdate[fieldName] === objValue) {
				//wenn das Field Dirty ist, dann immer updaten.
				if(dirtyFields.indexOf(fieldName) === -1) return;
			}
			lastFieldUpdate[fieldName] = objValue;

			const $formField = $me.find('[name="' + fieldName + '"]');
			const objError = data.fieldErrors[fieldName];

			if($formField.length > 0) {
				const attr_readonly = $formField.attr('readonly');
				const is_readonly = typeof attr_readonly !== typeof undefined && attr_readonly !== false;
				if (is_readonly || !objError) {

					if ($formField.is(':checkbox')) return;
					if ($formField.is(':radio')) return;

					$formField.val(objValue);
					if ($formField.hasClass('datetimepicker')) {
						$formField.trigger('input');
					}

				}
				return;
			}

			const $dbTextField = $me.find('.dbtext[data-name="' + fieldName + '"]');
			if($dbTextField.length > 0) {
				$dbTextField.text(objValue);
				return;
			}

			const $dbHtmlField = $me.find('.dbhtml[data-name="' + fieldName + '"]');
			$dbHtmlField.text(objValue);

		}

		return {
			'requestUpdate': requestUpdate,
			'updateUi': updateUi
		};

	};

})(jQuery, validationaware, window);